// extracted by mini-css-extract-plugin
module.exports = {"spidercard":"style_spidercard__1XGzu","mainContainer":"style_mainContainer__19LTr","spidernumber":"style_spidernumber__2hXBh","hideBtn":"style_hideBtn__3gyUX"};